import moment from "moment-timezone";

// time format, e.g: "0:00 AM"
export const TIME_FORMAT_12 = "h:mm A";
const REGEX = /12(:[0-9]+AM)/;

export default function get12hrTime({ hour, minutes }: Record<string, number>) {
  return moment({
    hour,
    minutes,
  })
    .format(TIME_FORMAT_12)
    .replace(REGEX, (_, p1) => `0${p1}`);
}
